import { PRISM_CANVAS_MIN_SIZE } from './prismConstants';
import type { PrismMutableRef, PrismScene } from './prismTypes';

interface ObservePrismResizeInput {
  scene: PrismScene;
  container: HTMLDivElement;
  offsetX: number;
  offsetY: number;
  scaleRef: PrismMutableRef<number>;
}

export function observePrismResize({
  scene,
  container,
  offsetX,
  offsetY,
  scaleRef,
}: ObservePrismResizeInput): ResizeObserver {
  const resize = (): void => {
    const width = getPrismCanvasSize(container.clientWidth);
    const height = getPrismCanvasSize(container.clientHeight);
    scene.renderer.setSize(width, height);
    scene.iResolutionBuffer[0] = scene.gl.drawingBufferWidth;
    scene.iResolutionBuffer[1] = scene.gl.drawingBufferHeight;
    scene.offsetPxBuffer[0] = offsetX * scene.dpr;
    scene.offsetPxBuffer[1] = offsetY * scene.dpr;
    const currentScale = Math.max(0.001, scaleRef.current);
    scene.program.uniforms.uPxScale.value = calculatePrismPxScale({
      drawingBufferHeight: scene.gl.drawingBufferHeight,
      scale: currentScale,
    });
  };

  const resizeObserver = new ResizeObserver(resize);
  resizeObserver.observe(container);
  resize();
  return resizeObserver;
}

interface CalculatePrismPxScaleInput {
  drawingBufferHeight: number;
  scale: number;
}

export function calculatePrismPxScale({ drawingBufferHeight, scale }: CalculatePrismPxScaleInput): number {
  return 1 / ((drawingBufferHeight || 1) * 0.1 * scale);
}

function getPrismCanvasSize(size: number): number {
  return size || PRISM_CANVAS_MIN_SIZE;
}
